// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/mobileBackground.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/largeBackground.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.main {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    min-height:110vh;
    background-size: cover;
    width:100%;
    margin:0;
    position: relative;
    overflow: hidden;
   
    

}

@media   (orientation: landscape) {
    .main {
      height: 900px;
    }
  }


@media screen and (min-width:1024px) {
    .main {
        height:125vh;
        width:100%;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    }
}


/* @media screen and (min-width:1340px) {
  .main {
    height: 140vh;
  }
} */


.cloud1 {
  position: absolute;
  animation-name: move;
  animation-duration: 4s;
  transition: all 4s; 
  animation-iteration-count: infinite;
  animation-timing-function:cubic-bezier();

}


@keyframes move {
  

  0%{left:100px};
  10%{left:0px};
  50%{left:50%};
  80%{left:100%};

}`, "",{"version":3,"sources":["webpack://./src/components/style.css"],"names":[],"mappings":";;AAEA;IACI,yDAAuD;IACvD,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;IACV,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;;;;AAIpB;;AAEA;IACI;MACE,aAAa;IACf;EACF;;;AAGF;IACI;QACI,YAAY;QACZ,UAAU;QACV,yDAAsD;IAC1D;AACJ;;;AAGA;;;;GAIG;;;AAGH;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;;AAE1C;;;AAGA;;;EAGE,GAAG,UAAU,CAAA;EACb,IAAI,QAAQ,CAAA;EACZ,IAAI,QAAQ,CAAA;EACZ,IAAI,SAAS,CAAA;;AAEf","sourcesContent":["\n\n.main {\n    background-image: url('../assets/mobileBackground.svg');\n    min-height:110vh;\n    background-size: cover;\n    width:100%;\n    margin:0;\n    position: relative;\n    overflow: hidden;\n   \n    \n\n}\n\n@media   (orientation: landscape) {\n    .main {\n      height: 900px;\n    }\n  }\n\n\n@media screen and (min-width:1024px) {\n    .main {\n        height:125vh;\n        width:100%;\n        background-image: url('../assets/largeBackground.svg');\n    }\n}\n\n\n/* @media screen and (min-width:1340px) {\n  .main {\n    height: 140vh;\n  }\n} */\n\n\n.cloud1 {\n  position: absolute;\n  animation-name: move;\n  animation-duration: 4s;\n  transition: all 4s; \n  animation-iteration-count: infinite;\n  animation-timing-function:cubic-bezier();\n\n}\n\n\n@keyframes move {\n  \n\n  0%{left:100px};\n  10%{left:0px};\n  50%{left:50%};\n  80%{left:100%};\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
